/* eslint-disable react/prop-types */
import { Dropdown } from 'react-bootstrap';

type DetailsAction = () => void;
// type RemoveAction = () => void;

interface ActionDropdownItemsProps {
  detailsAction?: DetailsAction; // Make the prop optional
  //   removeAction?: RemoveAction;
}

const StageDropdownItems: React.FC<ActionDropdownItemsProps> = ({
  detailsAction = () => {}
  //   removeAction = () => {}
}) => {
  return (
    <>
      <Dropdown.Item eventKey="1" className="text-info" onClick={detailsAction}>
        Details
      </Dropdown.Item>
      {/* <Dropdown.Item eventKey="2">Export</Dropdown.Item> */}
      {/* <Dropdown.Divider />
      <Dropdown.Item
        eventKey="2"
        className="text-danger"
        onClick={removeAction}
      >
        Remove
      </Dropdown.Item> */}
    </>
  );
};

export default StageDropdownItems;
